import { createFileRoute } from '@tanstack/react-router';

import { ProductForm } from '@/components/catalog/product-form';
import { useDetailTitle } from '@/components/page-header';
import {
  brandsCollection,
  categoriesCollection,
  productsCollection,
  productTagAssignmentsCollection,
  productTagsCollection,
  strainsCollection,
  variantsCollection,
} from '@/lib/collections';

/**
 * A static segment, so it takes precedence over `/products/$productId` and
 * "new" is never mistaken for an id.
 */
export const Route = createFileRoute('/products/new')({
  loader: async () => {
    /*
     * `productsCollection` is preloaded even though this screen renders no
     * list: an insert against a collection whose sync has not started is
     * rejected locally with "Collection must be in 'ready' state", *after* the
     * row has already reached Postgres. The write succeeds and the UI calls it
     * a failure — the one outcome worse than either.
     *
     * The other two are the brand and category pickers.
     */
    await Promise.all([
      productsCollection.preload(),
      variantsCollection.preload(),
      brandsCollection.preload(),
      categoriesCollection.preload(),
      strainsCollection.preload(),
      productTagsCollection.preload(),
      productTagAssignmentsCollection.preload(),
    ]).catch(() => undefined);
  },
  component: NewProductPage,
});

function NewProductPage() {
  useDetailTitle('New product');

  return <ProductForm />;
}
